import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientBySid = async ({ rootGetters }, { sid, vendorSid, oauthSignature }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const client = await stbApi.getClientBySid(sid, vendorSid, oauthSignature);
  return client;
};
